import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Tab, Tabs, Paper, Button, makeStyles } from '@material-ui/core'

import { CommonTable } from '../../components/CommonTable'
import AdminMainLayout from './AdminMainLayout'
import { adminS3GalleriesList, adminS3CheckSizeList, adminS3CheckFaceCountList } from '../actions/admin_s3'

const TabPanel = ({ children, value, index }) => {
    if (value !== index) {
        return null
    }
    return (
        <Box p={2}>
          {children}
        </Box>
    )
}

const formatMB = (bytes) => {
    if (!bytes) return '0.00 MB'
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB'
}

export const AdminS3 = () => {
    const dispatch = useDispatch()
    const [activeTab, setActiveTab] = useState(0)
    const [s3Sizes, setS3Sizes] = useState({})
    const [s3Loading, setS3Loading] = useState({})
    const [faceCounts, setFaceCounts] = useState({})
    const [faceLoading, setFaceLoading] = useState({})
    const classes = useStyles()
    const is_loading = useSelector(() => adminS3GalleriesList.isLoading())

    useEffect(() => {
        dispatch(adminS3GalleriesList.updateListPagination({items_per_page: 25, page: 1}))
        dispatch(adminS3GalleriesList.fetchListIfNeeded(true))
    }, [])

    const handleCheckFaceCount = async (galleryId) => {
        setFaceLoading((prev) => ({ ...prev, [galleryId]: true }))
        const data = await dispatch(adminS3CheckFaceCountList.check({ galleryId }))
        setFaceCounts((prev) => ({ ...prev, [galleryId]: data }))
        setFaceLoading((prev) => ({ ...prev, [galleryId]: false }))
    }

    const handleCheckS3Size = async (galleryId) => {
        setS3Loading((prev) => ({ ...prev, [galleryId]: true }))
        const data = await dispatch(adminS3CheckSizeList.check({ galleryId }))
        setS3Sizes((prev) => ({ ...prev, [galleryId]: data }))
        setS3Loading((prev) => ({ ...prev, [galleryId]: false }))
    }

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue)
    }

    const columns = [
        {
            field: 'primary_key',
            title: 'Gallery ID',
        },
        {
            field: 'created_at',
            title: 'Created At',
            render: (item) => {
                const date = new Date(item.created_at)
                return date.toLocaleString('en-GB', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                })
            }
        },
        {
            field: 'session_name',
            title: 'Session Name',
        },
        {
            field: 'num_photographs',
            title: 'Num Photos',
            align: 'right',
            width: 120,
        },
        {
            field: 'face_count',
            title: 'Faces',
            align: 'right',
            width: 150,
            render: (item) => {
                const galleryId = item.id
                const data = faceCounts[galleryId]
                const loading = faceLoading[galleryId]

                if (loading) return 'Loading...'
                if (data) {
                    if (!data.exists) return 'No collection'
                    return data.face_count
                }
                return (
                    <Button size="small" variant="outlined" onClick={() => handleCheckFaceCount(galleryId)}>
                      Check
                    </Button>
                )
            }
        },
        {
            field: 'total_size_bytes',
            title: 'Total Size',
            align: 'right',
            width: 120,
            render: (item) => formatMB(item.total_size_bytes)
        },
        {
            field: 's3_size',
            title: 'S3 Size',
            align: 'right',
            width: 150,
            render: (item) => {
                const galleryId = item.id
                const data = s3Sizes[galleryId]
                const loading = s3Loading[galleryId]

                if (loading) return 'Loading...'
                if (data) {
                    const label = formatMB(data.total_s3_bytes)
                    if (data.missing_count > 0) {
                        return label + ' (' + data.missing_count + ' missing)'
                    }
                    return label
                }
                return (
                    <Button size="small" variant="outlined" onClick={() => handleCheckS3Size(galleryId)}>
                      Check
                    </Button>
                )
            }
        },
    ]

    return (
        <AdminMainLayout active_key={"s3"}
                         title="S3 Storage">
          <div className={classes.root}>
            <Tabs value={activeTab}
                  onChange={handleTabChange}
                  className={classes.tabs}>
              <Tab label="Galleries" />
            </Tabs>
            <TabPanel value={activeTab} index={0}>
              <Paper variant="outlined" square>
                <CommonTable
                  is_loading={is_loading}
                  rows={adminS3GalleriesList.getVisibleObjects()}
                  columns={columns}
                  item_list={adminS3GalleriesList}
                  showFilters={false}
                  initialRowsPerPage={25}
                />
              </Paper>
            </TabPanel>
          </div>
        </AdminMainLayout>
    )
}

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    tabs: {
        borderBottom: '1px solid #ddd',
        marginBottom: 16,
    },
})
